export default __webpack_public_path__ + "static/media/iconDownload.3c7929a5.svg";